<template>
    <Custom404 v-if="error.statusCode === 404" />
    <CustomError v-else :errorCode="error.statusCode" :errorMessage="error.message"/>
</template>

<script>
export default {
  props: ['error'],

  mounted() {
    if (this.error.statusCode === 404) {
      this.notifyAdminAbout404();
    }
  },

  methods: {
    notifyAdminAbout404() {
      fetch(`${import.meta.env.VITE_WP_BASE_URL}/wp-json/fa/v1/notify-404`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': import.meta.env.VITE_WP_TOKEN
        },
        body: JSON.stringify({ url: window.location.href })
      })
      .catch(error => console.error('Error sending notification:', error));
    }
  }
}
</script>
